import type { ReactNode } from "react";

import { ConfirmDialog } from "../../components/ConfirmDialog";

/** Confirmation d'une action qui s'annule (⌘Z) et ne supprime rien, comme « Revenir au fuseau automatique » :
 *  `ConfirmDialog` au ton neutre (pastille d'information, bouton principal noir, sans le rouge réservé aux
 *  suppressions). Gardé pour ses appels ; tout code nouveau écrit `<ConfirmDialog tone="neutral">`. */
export function NeutralConfirm(props: {
  title: string;
  children: ReactNode;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return <ConfirmDialog tone="neutral" {...props} />;
}
